module.exports = __webpack_public_path__ + "static/stardust-card-focusable-e8685fa6a3e942da34816fc1ea714a71.gif";